export const SCROLL_MARGIN_TOP = 20;
export const SKIP_TO_MAIN_CONTENT_ANCHOR = 'inhalt';
